/* PANDI DPF Savings Fix v2 (2026-06-01 night, all-products edition)
 * v1 only fixed when an inline JSON had "handle" matching the URL. Many
 * products have JSON without handle, so the wrong-mattress 180k savings
 * still showed up. v2 ALWAYS fetches /products/<handle>.js (the canonical
 * Shopify endpoint) and rewrites .pandi-dpf-savings if/when cro-suite
 * inserts it. Idempotent, variant-aware, race-safe.
 * Reversible: delete this asset + remove the <script> in layout/theme.liquid. */
(function () {
  'use strict';

  function fmt(n) { return '₡' + Math.round(n).toLocaleString('es-CR'); }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\?\/#]+)/);
    return m ? m[1] : null;
  }
  function selectedVariantId() {
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return parseInt(m[1], 10);
    var inp = document.querySelector('#pdp-vid') || document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('[name="id"]');
    if (inp && inp.value && /^\d+$/.test(inp.value)) return parseInt(inp.value, 10);
    var sel = document.querySelector('.pdp-variant.is-selected[data-vid]') || document.querySelector('.pandi-variant.is-selected[data-variant-id]');
    if (sel) { var vv = sel.getAttribute('data-vid') || sel.getAttribute('data-variant-id'); if (vv && /^\d+$/.test(vv)) return parseInt(vv, 10); }
    return null;
  }
  function pickVariant(product, vid) {
    if (!product || !product.variants || !product.variants.length) return null;
    if (vid) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === vid) return product.variants[i];
      }
    }
    // Prefer the variant whose price/compare ratio is largest discount (so 1st
    // visible variant's savings is shown by default)
    return product.variants[0];
  }
  function savingsFor(variant) {
    if (!variant) return 0;
    var p = parseFloat(variant.price);
    var c = (variant.compare_at_price != null ? parseFloat(variant.compare_at_price) : (variant.compareAtPrice != null ? parseFloat(variant.compareAtPrice) : 0)) || 0;
    // /products/<handle>.js returns cents
    if (!isFinite(p) || p <= 0) return 0;
    if (!isFinite(c) || c <= 0) return 0;
    return Math.max(0, (c - p) / 100);
  }

  // Cache the fetched product JSON across re-renders so we don't refetch.
  var productPromise = null;
  function getProduct() {
    if (productPromise) return productPromise;
    var h = currentHandle();
    if (!h) return Promise.resolve(null);
    productPromise = fetch('/products/' + h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productPromise;
  }

  function applyFix(savings) {
    if (!savings || savings <= 0) return 0;
    var fixed = 0;
    var marker = String(Math.round(savings));
    document.querySelectorAll('.pandi-dpf-savings').forEach(function (el) {
      if (el.dataset.pandiSavingsFixed === marker) { fixed++; return; }
      var strong = el.querySelector('strong');
      if (!strong) return;
      strong.textContent = fmt(savings);
      el.dataset.pandiSavingsFixed = marker;
      fixed++;
    });
    return fixed;
  }

  function compute() {
    return getProduct().then(function (product) {
      if (!product) return 0;
      var vid = selectedVariantId();
      var v = pickVariant(product, vid);
      var s = savingsFor(v);
      return applyFix(s);
    });
  }

  function init() {
    if (!currentHandle()) return; // only on product pages

    // 1) Pre-fetch the product NOW so the data is hot when cro-suite runs
    getProduct();

    // 2) Try to fix every 150ms for the first 10s — covers all cro-suite render delays
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (document.querySelector('.pandi-dpf-savings')) compute();
      if (attempts >= 66) clearInterval(poll); // ~10s
    }, 150);

    // 3) MutationObserver: catch any late re-render by cro-suite
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (document.querySelector('.pandi-dpf-savings:not([data-pandi-savings-fixed])')) {
          compute();
        }
      });
      function start() { if (document.body) mo.observe(document.body, { childList: true, subtree: true }); }
      if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
    }

    // 4) Variant change — URL polling
    var lastSearch = location.search;
    setInterval(function () {
      if (location.search !== lastSearch) {
        lastSearch = location.search;
        document.querySelectorAll('.pandi-dpf-savings').forEach(function (el) { el.dataset.pandiSavingsFixed = ''; });
        compute();
      }
    }, 500);

    // 5) Theme variant:change event
    document.addEventListener('variant:change', function (e) {
      document.querySelectorAll('.pandi-dpf-savings').forEach(function (el) { el.dataset.pandiSavingsFixed = ''; });
      // If the event carries the new variant directly, use it without refetch
      try {
        var v = e && e.detail && e.detail.variant;
        if (v && v.price != null) {
          var sav = savingsFor(v);
          if (sav > 0) { applyFix(sav); return; }
        }
      } catch (err) {}
      compute();
    });

    // 6) Cross-tab / pushState support — wrap history.pushState too
    var origPush = history.pushState;
    history.pushState = function () {
      var r = origPush.apply(this, arguments);
      setTimeout(function () {
        document.querySelectorAll('.pandi-dpf-savings').forEach(function (el) { el.dataset.pandiSavingsFixed = ''; });
        compute();
      }, 50);
      return r;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
